var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "container",
          staticStyle: { "margin-top": "80px", "padding-top": "40px" },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
          }),
          _vm._v(" "),
          !_vm.rm
            ? _c(
                "p",
                [
                  _c("FileUploader", {
                    on: {
                      selected: function ($event) {
                        _vm.file = $event
                      },
                      unselected: function ($event) {
                        _vm.file = null
                      },
                      uploaded: _vm.loadMappings,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.rm
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: {
                      click: _vm.handleImportProjectPlansFromSpreadsheetCommand,
                    },
                  },
                  [_vm._v("Import")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    on: { click: _vm.cancelImport },
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "table table-bordered" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._l(_vm.rm.Sheets, function (s) {
                      return _c("tr", { key: s.SheetIndex }, [
                        _c("td", [_vm._v(_vm._s(s.SheetIndex))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(s.SheetName))]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            class: {
                              "table-success": s.ProjectExists,
                              "table-danger": !s.ProjectExists,
                            },
                          },
                          [_vm._v(_vm._s(s.ProjectName))]
                        ),
                        _vm._v(" "),
                        _c("td", {
                          class: {
                            "table-success": s.Timeline,
                            "table-danger": !s.Timeline,
                          },
                        }),
                        _vm._v(" "),
                        _c("td", {
                          class: {
                            "table-success": s.Capex,
                            "table-danger": !s.Capex,
                          },
                        }),
                      ])
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-6" }, [
        _c(
          "h1",
          {
            staticStyle: {
              "font-size": "2em",
              "font-weight": "300",
              color: "#33475b",
              margin: "0",
            },
          },
          [_vm._v("Import")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-lg-6 text-right align-self-end" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Sheet index")]),
        _vm._v(" "),
        _c("th", [_vm._v("Sheet name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Project name")]),
        _vm._v(" "),
        _c("th", [_vm._v("Timeline")]),
        _vm._v(" "),
        _c("th", [_vm._v("Capex")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }